module.exports = __webpack_public_path__ + "img/ro.fb40ec7.svg";